<script lang="ts">
import Spinner from "@/components/spinner.vue";
import AcousticForm from "@/shared/acoustic-form.vue";
import { useSubmitForm } from "@/shared/use-submit-form";
import { defineComponent, ref } from "vue";

export default defineComponent({
  components: {
    AcousticForm,
    Spinner,
  },
  setup() {
    const form = ref();

    const { onSubmit, state } = useSubmitForm(form, {
      lists: ["4237051"],
      redirect: "https://oukosher.org/thank-you-for-signing-up/",
    });

    return { form, onSubmit, state };
  },
});
</script>
<template>
  <AcousticForm>
    <div class="form-container">
      <form
        @submit.prevent="onSubmit"
        ref="form"
        v-if="state == 'idle' || state == 'submitting'"
      >
        <label class="label">Your Email Address *</label>
        <div class="form-row form-row--inline">
          <label for="control_EMAIL">
            <input id="control_EMAIL" required type="email" name="EMAIL" placeholder="Email" />
          </label>
          <input name="Collection Name" type="hidden" value="PG23" />
          <input id="control_COLUMN18" name="COLUMN18" type="hidden" value="control_COLUMN18" />
          <!-- <input name="RECIPIENT_ID_*" type="hidden" value="492193143258" /> -->
          <input name="formSourceName" type="hidden" value="StandardForm" />
          <button :disabled="state == 'submitting'">Submit</button>
        </div>
        
        <Spinner v-if="state == 'submitting'" />
      </form>
      <div v-else-if="state == 'error'">
        <div class="error-label">An error occurred.</div>
        <button @click="state = 'idle'">Go Back</button>
      </div>
    </div>
  </AcousticForm>
</template>

<style lang="scss" scoped>
.form-container {
  padding: 15px;
  background-color: #d3e8fc;
  max-width: 300px;
  margin: 0px 0px 10px;
  position: relative;
  overflow: hidden;
  width: 100%;
  border: 1px solid #ddd;
}

.form-row {
  max-width: 100%;
  @media only screen and (min-width: 720px) {
    &.form-row--inline {
      display: flex;
      justify-content: space-between;
      label{
        flex: 2;
      }
    }
    .form-row__half {
      flex: 1;
      margin: 0 auto;
      max-width: 40%;
    }
    .form-row__third {
      flex: 1;
      margin-bottom: 0px;
      max-width: 31%;
    }
  }
}

select {
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #f7f9fb;
  color: #222;
  cursor: pointer;
  width: 100%;
  outline: 0;
  box-sizing: border-box;
  min-width: 80px;
  transition: border-color 0.3s ease-in-out;
  font-size: 16px;
  align-items: center;
  box-shadow: none;
  display: inline-flex;
  height: 44px;
  justify-content: flex-start;
  padding: 0 10px;
  position: relative;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEuNDEgNC42NyAyLjQ4IDMuMTggMy41NCA0LjY3IDEuNDEgNC42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zMyAzLjU0IDUuMzMiLz48L3N2Zz4=");
  background-repeat: no-repeat;
  background-position: 95% 50%;
  @media only screen and (min-width: 720px) {
    height: 42px;
  }

  &:hover {
    border-color: #15329d;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border: 1px solid #e4e4e4;
    background: #f3f2f2;
  }
  &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
  }
}
label {
  display: block;
  margin-bottom: 0px;
}

input[type="email"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"],
textarea {
  display: inline-block;
  border: 1px solid #ddd;
  padding: 10px 12px;
  border-radius: 2px;
  font-size: 14px;
  background: white;
  box-shadow: none;
  width: 100%;
  text-align: left;
  font-family: Raleway;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: none;
  }

  &:focus {
    box-shadow: none;
    color: black;
    background: white;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border: 1px solid #e4e4e4;
    background: #f3f2f2;
  }
}
input::placeholder,
input:-ms-input-placeholder,
input::-ms-input-placeholder {
  opacity: 1;
  color: #cf9850 !important;
}

button {

  display: inline-block;
    text-align: center;
    color: #fff;
    text-decoration: none;
    background: #3674c0;
    padding: 15px 25px;
    border-radius: 2px;
    font-weight: 400;
    cursor: pointer;
  padding: 7px 25px;
  border-radius: 2px;
  border: none;
  margin: 0;
  font-weight: 600;
  cursor: pointer;
  box-shadow: none;
  font-family: inherit;
  -webkit-font-smoothing: inherit;
  letter-spacing: inherit;
  overflow: visible;
  transition: 0.3s;
  flex: 0 1 98px;
}
button:hover {
  background: #3674c0a8;
}

.error-label {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  padding: 15px;
  margin-bottom: 20px;
  transition: opacity 0.15s linear;
  border: 1px solid transparent;
  border-radius: 4px;
}

.success-label {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  padding: 15px;
  margin-bottom: 20px;
  transition: opacity 0.15s linear;
  border: 1px solid transparent;
  border-radius: 4px;

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  p {
    margin-top: 0px;
    margin-bottom: 10px;
  }
}

label.label{
  margin: 0px 3px 2px;
    font: 16px/1.6 "proxima-nova","sans-serif";
    color: #3c3839;
    font-weight: 400;
}
</style>
